module.exports = __webpack_public_path__ + "img/malraux.341cd4cf.jpeg";